const html = (i) => `
<html>
    <head>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css">
        <style>@media print{@page{size: A5 landscape}}</style>
    </head>
    <body class="A5 landscape" style="font-family:monospace;">
        <section class="sheet padding-10mm">
            <article>SERTEL GRUP LOJİSTİK A.Ş.</article>
            <br>
            <article>${i.FisTipi}</article>
            <hr/>
            <article>${i.Tarih || '*'}</article>
            <br/>
            <table style="border-collapse:collapse;width:100%">
                <tbody>
                    <tr>
                        <td style="vertical-align:top; width:50%" rowspan="3">Fis No: ${i.FisNo}</td>
                        <td>Kayıt Yapan Kul.: ${i.KayitYapanKullanici}</td>
                    </tr>
                    <tr>
                        <td>Proje Kodu: ${i.ProjeKodu}</td>
                    </tr>
                    <tr>
                        <td>Tarih: ${i.Tarih}</td>
                    </tr>
                </tbody>
            </table>
            <hr/>
            <table border="1" style="border-collapse:collapse; table-layout: fixed; width:100%">
                <thead>
                    <tr>
                        <th style="padding:4px;text-align:left;white-space: nowrap;"><u>HESAP KODU</u></th>
                        <th style="padding:4px;text-align:left;white-space: nowrap; overflow: hidden;text-overflow: clip;"><u>HESAP ADI</u></th>
                        <th style="padding:4px;text-align:left;white-space: nowrap; width:auto"><u>ACIKLAMA</u></th>
                        <th style="padding:4px;text-align:left;white-space: nowrap;"><u>BORC</u></th>
                        <th style="padding:4px;text-align:left;white-space: nowrap;"><u>ALACAK</u></th>
                    </tr>
                </thead>
                <tbody>
                    ${tableRows(i.Items || [])}
                    <tr>
                        <td colspan="3" style="text-align:right">Genel Toplam: </td>
                        <td>${i.GenelBorc || ''}</td>
                        <td>${i.GenelAlacak || ''}</td>
                    </tr>
                </tbody>
            </table>
            <br/>
            <table style="width:100%">
                <tr>
                    <td style="width:50%; text-align:center;">
                        <u>HAZIRLAYAN</u>
                        <br/>
                        ${i.Hazirlayan}
                    </td>
                    <td style="width:50%; text-align:center;">
                        <u>ONAYLAYAN</u>
                    </td>
                </tr>
            </table>
        </section>
    </body>
</html>
`

const tableRows = (rows) => {
    const rs = []
    for (let index = 0; index < rows.length; index++) {
        rs.push(`
            <tr>
                <td style="vertical-align:top;white-space: nowrap; overflow: hidden; text-overflow: clip; padding:4px;">${rows[index].HesapKodu}</td>
                <td style="vertical-align:top;padding:4px;">${rows[index].HesapAdi}</td>
                <td style="vertical-align:top;padding:4px;">${rows[index].Aciklama}</td>
                <td style="vertical-align:top;white-space: nowrap; padding:4px; white-space: nowrap; overflow: hidden; text-overflow: clip;">${rows[index].Borc}</td>
                <td style="vertical-align:top;white-space: nowrap; padding:4px; white-space: nowrap; overflow: hidden; text-overflow: clip;">${rows[index].Alacak}</td>
            </tr>
        `)
    }
    return rs.join('')
}

const settings = `toolbar=no,
location=no,
status=no,
menubar=no,
scrollbars=yes,
resizable=yes,
width=830,
height=590`

export const printFaturaFis = (i) => {
    var wnd = window.open("about:blank", "", settings);
    wnd.document.write(html(i));
    wnd.print()
}